import { render, staticRenderFns } from "./TravelAreas.vue?vue&type=template&id=461a4661&"
import script from "./TravelAreas.vue?vue&type=script&lang=js&"
export * from "./TravelAreas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports